import React from 'react';

type Props = {
  type?: string | null;
};

const CATEGORY_ICONS: { [s: string]: string } = {
  APPLE_PAY: 'apple_pay@2x.png',
  BANK: 'bank@2x.png',
  CARD: 'card@2x.png',
  GOOGLE_PAY: 'google_pay@2x.png',
  PAYPAL_ACCOUNT: 'paypal_account@2x.png',
  PAYPAL_CREDIT: 'paypal_credit@2x.png',
  VENMO: 'venmo@2x.png'
};

export default ({ type }: Props) => {
  return CATEGORY_ICONS[type || ''] ? (
    <img
      style={{
        width: 'auto',
        height: 'auto',
        maxHeight: '3em',
        maxWidth: '3em',
      }}
      src={require(`../../../images/${CATEGORY_ICONS[type || '']}`)}
    />
  ) : null;
};
